/** Every line this layer says to the player, in the menus' voice: what happened, and what it means for his save. */

export const MSG = {
  newCode: 'NOTHING HAS BEEN SENT YET. THE FIRST SAVE GOES TO THE SERVER UNDER THIS DEVICE\'S CODE.',
  pulled: 'THE LATEST SAVE WAS LOADED FROM THE SERVER.',
  serverEmpty: 'THE SERVER HOLDS NOTHING UNDER THIS CODE. THIS DEVICE\'S SAVE WILL BE SENT.',
  offline: 'THE SERVER IS NOT ANSWERING. SAVES ARE KEPT ON THIS DEVICE AND SENT WHEN IT DOES.',
  otherDevice: 'ANOTHER DEVICE HAS SAVED UNDER THIS CODE. NOTHING MORE IS SENT FROM HERE UNTIL THE GAME IS'
    + ' STARTED AGAIN; THE TWO SAVES ARE SETTLED THEN, AND THE ONE THAT LOSES IS KEPT AS A BACKUP.',
  localWon: 'TWO DEVICES HAD BOTH PLAYED. THIS DEVICE WAS FURTHER ON, SO ITS SAVE WAS KEPT; THE OTHER IS STORED'
    + ' IN THIS BROWSER AS A BACKUP.',
  remoteWon: 'TWO DEVICES HAD BOTH PLAYED. THE OTHER WAS FURTHER ON, SO ITS SAVE WAS LOADED; THIS DEVICE\'S IS'
    + ' STORED IN THIS BROWSER AS A BACKUP.',
  tooLarge: 'PART OF THE SAVE IS TOO LARGE FOR THE SERVER AND STAYS ON THIS DEVICE ONLY.',
  replaced: 'THE SAVE UNDER THAT CODE IS NOW ON THIS DEVICE.',

  unavailable: 'CLOUD SAVES ARE NOT AVAILABLE HERE.',
  badCode: 'THAT IS NOT A VALID CODE. CHECK EVERY CHARACTER AND TRY AGAIN.',
  sameCode: 'THIS DEVICE ALREADY USES THAT CODE.',
  noSave: 'NO SAVE IS STORED UNDER THAT CODE.',
  unreachable: 'THE SERVER COULD NOT BE REACHED. NOTHING WAS CHANGED; TRY AGAIN.',
  noRoom: 'THIS BROWSER HAS NO ROOM TO STORE THAT SAVE. NOTHING WAS CHANGED.',
} as const;

export function refusedMessage(status: number): string {
  return `THE SERVER REFUSED THE REQUEST (${status}). NOTHING MORE IS SENT UNTIL THE GAME IS STARTED AGAIN.`;
}
